// removed by extract-text-webpack-plugin
module.exports = {"articleContent":"styles__articleContent___23kR5","imgContainer":"styles__imgContainer___HOYJn","articleFooter":"styles__articleFooter___AeO5p","heading":"styles__heading___3mXCz","header":"styles__header___WGuMR","moreArticles":"styles__moreArticles___thE1s","postContainer":"styles__postContainer___rgHQB","trendingArticles":"styles__trendingArticles___2Aj40","trendingHeading":"styles__trendingHeading____vDH7","bottomAd":"styles__bottomAd___2OjGn","videoElement":"styles__videoElement___1b73y","videoElementContainer":"styles__videoElementContainer___2uklX"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/post/styles.css
// module id = Rn0q
// module chunks = 3